import '../components/toast';

let toastDom: HTMLElement | null;

export function showToast(text: string) {
  if (!toastDom) {
    toastDom = document.createElement('tiktok-cookie-banner-toast');
    toastDom.setAttribute('text', text);
    toastDom.setAttribute('text-id', Date.now().toString(36));
    const fadeOutCompleteHandler = () => {
      if (!toastDom) {
        return;
      }
      toastDom.removeEventListener('fadeOutComplete', fadeOutCompleteHandler);
      document.body.removeChild(toastDom);
      toastDom = null;
    };
    toastDom.addEventListener('fadeOutComplete', fadeOutCompleteHandler);
    document.body.appendChild(toastDom);
  } else {
    toastDom.setAttribute('text', text);
    toastDom.setAttribute('text-id', Date.now().toString(36));
  }
}

/**
 * This is provided as a workaround for custom fonts in web-component. See Chrome bug report https://bugs.chromium.org/p/chromium/issues/detail?id=336876
 * @param fontUrl
 */
export function loadCustomFonts(fontName: string, fontUrl: string) {
  let element = document.querySelector(`style[data-tiktok-cookie-banner-font='${fontName}']`);

  // Only inject the element if it's not yet present
  if (!element) {
    element = document.createElement('style');
    element.setAttribute('data-tiktok-cookie-banner-font', fontName);
    element.innerHTML = `
  @font-face {
    font-family: "${fontName}";
    src: url("${fontUrl}");
    font-display: swap;
  }
    `;
    document.head.appendChild(element);
  }
}

const byteLocale = /ByteLocale\//;
const ByteFullLocale = /ByteFullLocale\//;

export function isInApp() {
  return byteLocale.test(navigator.userAgent) || ByteFullLocale.test(navigator.userAgent);
}
